import React from 'react';
import { bool, func, oneOf, oneOfType, number, string, node } from 'prop-types';
import { CondensedMedium, Gutter, Layout } from '@axiom/ui';

import Checkbox from '../Checkbox/Checkbox';
import { formatDataTestId } from '../../utils/data-test-util';

export const CheckboxWithLabel = ({
  checked,
  disabled,
  id,
  label,
  name,
  type,
  value,
  className,
  onValueChange,
  checkboxWidth,
  checkboxHeight,
  ...rest
}) => {
  const handleChange = e => {
    onValueChange(e.target.checked);
  };

  return (
    <Layout
      disabled={disabled}
      data-test={formatDataTestId(name || id || label || 'CHECKBOX_CONTAINER')}
      className={className}
    >
      <Checkbox
        checked={checked}
        onValueChange={handleChange}
        data-test={formatDataTestId('CHECKBOX')}
        data-value={checked ? 'checked' : 'unchecked'}
        inputProps={{
          ...rest,
          id,
          name: name || id,
          type,
          value,
          disabled,
        }}
        width={checkboxWidth}
        height={checkboxHeight}
      />
      {!!label && (
        <Gutter left="8px" bottom="4px">
          <CondensedMedium name="LABEL_TEXT">{label}</CondensedMedium>
        </Gutter>
      )}
    </Layout>
  );
};

CheckboxWithLabel.defaultProps = {
  disabled: false,
  checked: false,
  className: undefined,
  name: undefined,
  onValueChange: () => {},
  type: 'checkbox',
  value: undefined,
  checkboxWidth: undefined,
  checkboxHeight: undefined,
};

CheckboxWithLabel.propTypes = {
  checkboxHeight: string,
  checkboxWidth: string,
  checked: bool,
  className: string,
  disabled: bool,
  id: string.isRequired,
  label: oneOfType([string, node]).isRequired,
  name: string,
  type: oneOf(['radio', 'checkbox']),
  value: oneOfType([bool, number, string]),
  onValueChange: func,
};
